import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";

export default function Step1Company({ duplicateField }) {
  const { errors, touched, setFieldValue, values } = useFormikContext();

  const handleFile = (e) => {
    const file = e.currentTarget.files && e.currentTarget.files[0];
    setFieldValue("file", file || null);
  };

  return (
    <>
      <h5 className="mb-1">Step 1 — Company basics</h5>
      <p className="text-muted small mb-4">
        Tell us about the customer. The domain becomes part of their portal URL.
      </p>

      <div className="form-group mt-2">
        <label htmlFor="companyName">Company name</label>
        <Field
          id="companyName"
          name="companyName"
          type="text"
          className={`form-control ${
            (errors.companyName && touched.companyName) || duplicateField === "companyName"
              ? "is-invalid"
              : ""
          }`}
          placeholder="Acme Insurance"
        />
        {duplicateField === "companyName" ? (
          <div className="invalid-feedback d-block">
            A company with this name already exists.
          </div>
        ) : (
          <ErrorMessage name="companyName" component="div" className="invalid-feedback" />
        )}
      </div>

      <div className="form-group mt-3">
        <label htmlFor="companyDomain">Company domain</label>
        <Field
          id="companyDomain"
          name="companyDomain"
          type="text"
          className={`form-control ${
            (errors.companyDomain && touched.companyDomain) || duplicateField === "companyDomain"
              ? "is-invalid"
              : ""
          }`}
          placeholder="acme.com"
        />
        {duplicateField === "companyDomain" ? (
          <div className="invalid-feedback d-block">
            A company with this domain already exists.
          </div>
        ) : (
          <ErrorMessage name="companyDomain" component="div" className="invalid-feedback" />
        )}
      </div>

      <div className="form-group mt-3">
        <label htmlFor="senderEmail">Sender email</label>
        <Field
          id="senderEmail"
          name="senderEmail"
          type="email"
          className={`form-control ${
            errors.senderEmail && touched.senderEmail ? "is-invalid" : ""
          }`}
          placeholder="no-reply@acme.com"
        />
        <ErrorMessage name="senderEmail" component="div" className="invalid-feedback" />
        <small className="text-muted d-block mt-1">
          Outbound portal emails (invites, notifications) will appear to come from this address.
        </small>
      </div>

      <div className="form-group mt-3">
        <label htmlFor="file">Company logo (optional)</label>
        <input
          id="file"
          name="file"
          type="file"
          accept="image/*"
          className="form-control"
          onChange={handleFile}
        />
        {values.file && (
          <small className="text-muted d-block mt-1">
            Selected: {values.file.name}
          </small>
        )}
      </div>
    </>
  );
}
